var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFewClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    transform: "scale(0.7)",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#87cefa",
    fillOpacity: 0,
    d: "M0 0h1024v1024H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#87cefa",
    d: "M646.698667 144.554667c101.034667 0 187.989333 67.712 217.685333 164.650666 82.261333 28.885333 139.434667 106.666667 139.434667 194.944 0 56.704-23.338667 97.706667-66.432 122.197334 1.536 10.112 2.304 20.48 2.304 31.018666 0 120.32-99.242667 217.472-221.44 217.472H263.978667c-133.717333 0-242.261333-109.226667-242.261334-243.669333a243.968 243.968 0 0 1 128.768-215.296C178.261333 316.970667 267.349333 246.613333 369.92 246.613333a218.026667 218.026667 0 0 1 78.805333 14.464c40.96-71.381333 114.858667-116.565333 197.973334-116.565333z m-86.826667 188.8c-75.946667 0-143.402667 45.226667-174.037333 114.432l-11.264 25.472-24.704-12.885334a185.045333 185.045333 0 0 0-85.845334-20.608c-104.789333 0-189.994667 85.76-189.994666 191.402667s85.205333 191.402667 189.994666 191.402667h454.186667c93.610667 0 169.216-73.984 169.216-165.205334 0-74.624-51.370667-139.349333-124.373333-158.72l-15.018667-4.010666-3.669333-15.146667a190.293333 190.293333 0 0 0-184.490667-146.133333z m86.826667-136.533334c-65.28 0-123.306667 36.266667-154.666667 93.952a240.64 240.64 0 0 1 67.84-9.728 242.474667 242.474667 0 0 1 231.296 171.52 219.562667 219.562667 0 0 1 131.370667 121.002667c19.413333-15.189333 29.013333-37.162667 29.013333-69.418667 0-69.546667-47.957333-130.730667-115.456-149.034666l-14.933333-4.053334-3.626667-15.061333c-19.584-81.621333-89.429333-139.221333-170.837333-139.221333zM369.92 298.88c-65.066667 0-123.392 37.12-153.813333 93.312a243.498667 243.498667 0 0 1 133.845333 10.922667 244.522667 244.522667 0 0 1 88.96-89.514667 164.693333 164.693333 0 0 0-68.992-14.72z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewClouds);
export default __webpack_public_path__ + "static/media/few-clouds.5fa31e4a84248ea68083198a2c8f22cf.svg";
export { ForwardRef as ReactComponent };